import Bjax from '@bilibili/bjax'
import queryString from 'query-string'
import { getCookie } from './utils'
const bjax = new Bjax()
// 获取用户信息
export const fetchUserInfo = () =>
  bjax.get(`//api.bilibili.com/x/web-interface/nav`)

// 用户退出登录
export const logOut = () => bjax.post(`//passport.bilibili.com/login/exit/v2?biliCSRF=${getCookie('bili_jct')}`, queryString.stringify({ biliCSRF: getCookie('bili_jct') }), {
  // headers: {
  //   'Content-Type': 'application/x-www-form-urlencoded',
  // },
})
